import { enableProdMode } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'

import { AppModule } from './app/app.module'
import { environment } from './environments/environment'
import { registerLicense } from '@syncfusion/ej2-base'
import { oneTimeCacheBust } from './oneTimeCacheBust'

registerLicense('ORg4AjUWIQA/Gnt2VVhiQlFadVlJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxRdkxiXX5fc3NXTmdbVUw=')

const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule)

if (environment.production) {
  oneTimeCacheBust() // TODO: ASPIK-689 remove after 09/2025

  enableProdMode()
  bootstrap().catch((err) => console.log(err))
} else {
  bootstrap().catch((err) => console.log(err))
}
